import PropTypes from 'prop-types';

export const EmergencyHistoryShape = PropTypes.shape({
  poiId: PropTypes.number,
  updateDate: PropTypes.string,
  nickname: PropTypes.string,
  stamp: PropTypes.string,
  reportType: PropTypes.string,
  reportStatus: PropTypes.bool,
});

export default PropTypes.shape({
  poiId: PropTypes.string,
  hasPower: EmergencyHistoryShape,
  hasGas: EmergencyHistoryShape,
  hasDiesel: EmergencyHistoryShape,
});
